import type { Degree } from "@pdfking/math"
import { Sign, ToRadians } from "@pdfking/math"

import type { FoldCell } from "#public"

// How far a fold stands off flat, open or closed, at `ajar` 1
const MAX_AJAR = ToRadians(20 as Degree)

/** How far `fold` stands off, its own ajar times the viewer's `ajar`
 * setting, turned its angle's way. */
export const FoldAjar = (fold: FoldCell, ajar: number): number =>
  Sign(fold.angle) * MAX_AJAR * ajar * fold.ajar

/** An open fold stops its ajar short of flat, never past it. */
export const FoldOpenTarget = (fold: FoldCell, ajar: number): number =>
  fold.ajar > 0 ? FoldAjar(fold, ajar) : 0

/** A closed fold stands its ajar off its angle while `next` to open, and
 * past its angle whenever its ajar is negative: tucked in. */
export const FoldClosedTarget = (fold: FoldCell, next: boolean, ajar: number): number =>
  next || fold.ajar < 0 ? fold.angle - FoldAjar(fold, ajar) : fold.angle
